import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { faqs } from '../../data/faqs';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faqs" aria-labelledby="faqs-title" className="bg-white py-20 text-ink lg:py-24" data-id="element-163" data-mp="x5mvahlnetpa">
      <div className="mx-auto max-w-3xl px-5 lg:px-8" data-id="element-164" data-mp="124ppf703bfih">
        <SectionHeading id="faqs-title" tone="light" eyebrow="FAQ" lead="Frequently asked" highlight="questions" data-id="element-165" data-mp="1prxw9td62wmm" />

        <ul className="mt-12 space-y-3" data-id="element-166" data-mp="1upze6ayuwpwi">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const buttonId = `faq-button-${index}`;
          const panelId = `faq-panel-${index}`;
          return <li key={faq.question} className={`border ${isOpen ? 'border-forest' : 'border-[#E5E7EB]'}`} data-id="element-167" data-mp="28rbsyj2a6lgt" data-mpi={index}>
                <h3 data-id="element-168" data-mp="2dibp3m3kszi9">
                  <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex min-h-[64px] w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6" data-id="element-169" data-mp="2ditrl0gu09ym">
                    <span className="text-[17px] font-bold leading-snug" data-id="element-170" data-mp="2toaefh316sre">{faq.question}</span>
                    <span aria-hidden="true" className={`flex h-9 w-9 shrink-0 items-center justify-center transition-colors duration-150 ${isOpen ? 'bg-forest text-gold' : 'bg-mint text-forest'}`} data-id="element-171" data-mp="37fxabft29z9n">
                      <PlusIcon strokeWidth={2.75} className={`h-5 w-5 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-172" data-mp="3cgupdjiryd6x" />
                    </span>
                  </button>
                </h3>
                <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!isOpen} data-id="element-173" data-mp="27qpew58l0tdc">
                  <p className="px-5 pb-6 text-base leading-relaxed text-[#374151] sm:px-6" data-id="element-174" data-mp="2bqrb3yvjsul8">{faq.answer}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}